// extracted by mini-css-extract-plugin
export default {"icon":"SVGIcon-module__icon--fV131","small":"SVGIcon-module__small--NRrGa","large":"SVGIcon-module__large--Rjtub","inline":"SVGIcon-module__inline--myTLc"};